import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import {
    Card,
    FormGroup,
    Alert,
    CardBody,
    CardTitle,
    CardFooter
} from "reactstrap";
import Box from "@mui/material/Box";
import GetAppIcon from "@mui/icons-material/GetApp";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { dealerAgentProfile } from '../../redux/actions/dealerAgentProfileAction'
import SOLogout from "../../components/Logout/SOLogout";
import { ExpandMore } from "@mui/icons-material";

import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Accordion,
    TextField,
    AccordionSummary,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    AccordionDetails
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import Typography from "@mui/material/Typography";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const DealerViewUserMaster = () => {
    const location = useLocation();
    const dealerId = location.state.param1;
    const [viewProfileStatus, setViewProfileStatus] = useState(false);

    const [viewProfileArray, setViewProfileArray] = useState([]);

    const partnerloginUser = useSelector(({ login }) => login);
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;


    const viewDealerProfileRes = useSelector(
        ({ dealerAgentProfiles }) => dealerAgentProfiles
    );
    const dispatch = useDispatch();



    const agentProfileReq = () => {
        setViewProfileStatus(true);
        let req = {

            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                customerId: dealerId
            }
        };

        return dispatch(dealerAgentProfile(req, authToken));
    };
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            // dispatch(resetDealerViewDsrList());
            agentProfileReq();
        }
    }, [regenerateTokenRes.data.status]);


    const viewAgentProfileFunc = () => {
        if (viewProfileStatus) {
            if (viewDealerProfileRes.data.status == "success") {
                setViewProfileArray(viewDealerProfileRes.data);
                // setViewKycDetailsArray(obj);
            }
            if (viewDealerProfileRes.data.status == "failed") {
                setViewProfileArray(viewDealerProfileRes.data);
                if (
                    viewDealerProfileRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    viewDealerProfileRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        viewAgentProfileFunc();
    }, [viewDealerProfileRes.data.status]);
    return (
        <>
            <Layout>
                <BackButton />
                <div style={{ background: "white", borderRadius: "5px" }}>
                    <Box marginLeft={3} marginRight={3} paddingBottom={2}>
                        <Typography
                            variant="h6"
                            component="div"
                            className=""
                            style={{
                                fontSize: "1.4rem",
                                marginBottom: "1.2rem",
                                color: "#013c83",
                                textAlign: "center",
                                fontWeight: "600"
                            }}
                        >
                            <Col md={12}>

                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                    viewProfileArray.customerMasterDetailsResponseVO
                                        .userRole} {""} */}

                                Agent/Merchant Details


                            </Col>
                        </Typography>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography style={{ color: "#013c83" }}>
                                    Request Registration Details
                                </Typography>
                            </AccordionSummary>
                            {/* <Alert
						className="text-left themeBackground"
						variant="secondary"
						// fullWidth={true}
						style={{ borderRadius: "0" }}
					>
						<Typography variant="body1">
							Request Registration Details
						</Typography>
					</Alert> */}
                            {/* <Box marginLeft={3} marginRight={3} paddingBottom={2}> */}
                            {/* <div
							style={{
								marginTop: "2rem"
							}}
						> */}
                            <AccordionDetails style={{ display: "unset" }}>
                                <Typography>
                                    <Col md={12}>
                                        <Row className="detail-info row">
                                            <Col md={6}>Agent/Merchant ID: </Col>
                                            <Col md={6}>
                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .customerId == ""
                                                    ? "-"
                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .customerId

                                                }
                                                {/* 
                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .businessAccountMasterVOList &&
                                                    viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .businessAccountMasterVOList.companyId == ""
                                                    ? "-"
                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .businessAccountMasterVOList &&
                                                    viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .businessAccountMasterVOList.companyId} */}
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="detail-info row">
                                            <Col md={6}>Role:</Col>
                                            <Col md={6}>
                                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .userRole} */}

                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .userRole == ""
                                                    ? "-"
                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .userRole

                                                }
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="detail-info row">
                                            <Col md={6}>Entity Type:</Col>
                                            <Col md={6}>
                                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .entityType} */}

                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .entityType == ""
                                                    ? "-"
                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .entityType

                                                }
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="detail-info row">
                                            <Col md={6}>Created By:</Col>
                                            <Col md={6}>
                                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .initiatedBy} */}
                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .initiatedBy == ""
                                                    ? "-"
                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .initiatedBy

                                                }

                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="detail-info row">
                                            <Col md={6}>Modified By:</Col>
                                            <Col md={6}>
                                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .modifiedBy} */}
                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .modifiedBy == ""
                                                    ? "-"
                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                        .modifiedBy

                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        {/* <div
                            style={{
                                marginTop: "2rem"
                            }}
                        >
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography style={{ color: "#013c83" }}>
                                        Wallet Balance
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails style={{ display: "unset" }}>
                                    <Typography>
                                        <Col md={12}>
                                            <Row className="detail-info row">
                                         
                                                <Col md={4}>
                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray.customerMasterDetailsResponseVO
                                                            .walletList.currency}{""}
                                                    :

                                                </Col>
                                                <Col md={4}>
                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray.customerMasterDetailsResponseVO
                                                            .walletList.balance}


                                                </Col>
                                                <Col md={4}>
                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray.customerMasterDetailsResponseVO
                                                            .walletList.storeId}{""}


                                                </Col>
                                            </Row>
                                            <hr />


                                        </Col>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div> */}
                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .walletList ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ color: "#013c83" }}>
                                            Wallet Balance
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Table size="medium" aria-label="purchases">
                                            <TableHead>
                                                <TableRow style={{ background: "#00b9f5" }}>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Store Id
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Currency
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Balance
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                    viewProfileArray
                                                        .customerMasterDetailsResponseVO.walletList &&
                                                    []
                                                        .concat(
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.walletList
                                                        )
                                                        .map((detail, i) => {
                                                            return (
                                                                <TableRow key={i + 1}>
                                                                    <TableCell
                                                                        style={{
                                                                            width: "35%",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {/* {`${detail.currency} -  ${detail.balance}`}{" "} */}
                                                                        {detail.storeId == ""
                                                                            ? "-"
                                                                            : detail.storeId}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            width: "35%",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {/* {`${detail.currency} -  ${detail.balance}`}{" "} */}
                                                                        {detail.currency == ""
                                                                            ? "-"
                                                                            : detail.currency}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            width: "35%",
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {detail.balance == ""
                                                                            ? "-"
                                                                            : detail.balance}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                            </TableBody>
                                        </Table>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}
                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .kycAndKybDetailsList ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >

                                        <Typography style={{ color: "#013c83" }}>
                                            {viewProfileArray.customerMasterDetailsResponseVO &&
                                                viewProfileArray.customerMasterDetailsResponseVO.businessPersonRequestVOList
                                                    .firstName} {""}

                                            Details
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionSummary
                                        // expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ color: "#013c83" }}>
                                            KYC Details
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Typography>
                                            <Col md={12}>
                                                <Row className="detail-info row">
                                                    <Col md={6}>Action: </Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.action == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.action}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification ID:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.regFraudId == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.regFraudId}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Request ID:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.fraudScore == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.fraudScore}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Request status:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.requestStatus == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.requestStatus}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Request Date:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.requestTime == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.requestTime}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Response ID:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.fraudScore == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.fraudScore}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification status:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.recommendation == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.recommendation}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification Description:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.description == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.description}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification Type:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.checkType == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.checkType}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Score:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.fraudScore == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.fraudScore}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Recommendation:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.recommendation == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.recommendation}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Confidence Level:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.confidenceLevel == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.confidenceLevel}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verified On:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.lastUpdatedTime == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.lastUpdatedTime}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verified By:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.modifiedBy == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kycAndKybDetailsList.modifiedBy}
                                                </Row>


                                            </Col>
                                        </Typography>
                                    </AccordionDetails>

                                    {/* 
                                    <AccordionDetails style={{ display: "unset" }}>
                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                            viewProfileArray.customerMasterDetailsResponseVO
                                                .kycAndKybDetailsList &&
                                            []
                                                .concat(
                                                    viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .kycAndKybDetailsList
                                                )
                                                .map((details) => {
                                                    return (
                                                        <>
                                                            <div
                                                                style={{
                                                                    // marginTop: "2rem",
                                                                    marginLeft: "1rem",
                                                                    marginRight: "1rem",
                                                                    marginBottom: "2rem"
                                                                }}
                                                            >

                                                                <Accordion>

                                                                    <AccordionSummary
                                                                        // expandIcon={<ExpandMore />}
                                                                        aria-controls="panel1a-content"
                                                                        id="panel1a-header"
                                                                    >
                                                                        <Typography style={{ color: "#013c83" }}>
                                                                            {details.action}
                                                                        </Typography>
                                                                    </AccordionSummary>

                                                                    <Typography>
                                                                        <Col md={12}>
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>ACTION</Col>
                                                                                <Col md={6}>
                                                                                    {details.action == ""
                                                                                        ? "-"
                                                                                        : details.action}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Verification ID</Col>
                                                                                <Col md={6}>
                                                                                    {details.regFraudId == ""
                                                                                        ? "-"
                                                                                        : details.regFraudId}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Request ID</Col>
                                                                                <Col md={6}>
                                                                                    {details.requestId == ""
                                                                                        ? "-"
                                                                                        : details.requestId}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Request status</Col>
                                                                                <Col md={6}>
                                                                                    {details.requestStatus == ""
                                                                                        ? "-"
                                                                                        : details.requestStatus}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Request Date</Col>
                                                                                <Col md={6}>
                                                                                    {details.requestTime == ""
                                                                                        ? "-"
                                                                                        : details.requestTime}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Response ID</Col>
                                                                                <Col md={6}>
                                                                                    {details.responseId == ""
                                                                                        ? "-"
                                                                                        : details.responseId}
                                                                                </Col>
                                                                            </Row>{" "}
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Verification status</Col>
                                                                                <Col md={6}>
                                                                                    {details.requestStatus == ""
                                                                                        ? "-"
                                                                                        : details.requestStatus}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>
                                                                                    Verification Description
                                                                                </Col>
                                                                                <Col md={6}>
                                                                                    {details.description == ""
                                                                                        ? "-"
                                                                                        : details.description}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Verification Type</Col>
                                                                                <Col md={6}>
                                                                                    {details.checkType == ""
                                                                                        ? "-"
                                                                                        : details.checkType}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Score</Col>
                                                                                <Col md={6}>
                                                                                    {details.fraudScore == ""
                                                                                        ? "-"
                                                                                        : details.fraudScore}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Recommendation</Col>
                                                                                <Col md={6}>
                                                                                    {details.recommendation == ""
                                                                                        ? "-"
                                                                                        : details.recommendation}
                                                                                </Col>
                                                                            </Row>{" "}
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Confidence Level</Col>
                                                                                <Col md={6}>
                                                                                    {details.confidenceLevel == ""
                                                                                        ? "-"
                                                                                        : details.confidenceLevel}
                                                                                </Col>
                                                                            </Row>{" "}
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Verified On</Col>
                                                                                <Col md={6}>
                                                                                    {details.lastUpdatedTime == ""
                                                                                        ? "-"
                                                                                        : details.lastUpdatedTime}
                                                                                </Col>
                                                                            </Row>
                                                                            <hr />
                                                                            <Row className="detail-info row">
                                                                                <Col md={6}>Verified By</Col>
                                                                                <Col md={6}>
                                                                                    {details.modifiedBy == ""
                                                                                        ? "-"
                                                                                        : details.modifiedBy}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Typography>
                                                                </Accordion>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                    </AccordionDetails> */}



                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                        viewProfileArray.customerMasterDetailsResponseVO
                                            .businessPersonRequestVOList ? (
                                        <div
                                            style={{
                                                marginTop: "2rem"
                                            }}
                                        >

                                            <AccordionSummary
                                                // expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography style={{ color: "#013c83" }}>
                                                    Personal Details
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ display: "unset" }}>
                                                <Typography>
                                                    <Col md={12}>
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Person ID:</Col>
                                                            <Col md={6}>
                                                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.personId} */}

                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.personId == ""
                                                                    ? "-"
                                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.personId}

                                                            </Col>
                                                        </Row>

                                                        <hr />
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Name:</Col>
                                                            <Col md={6}>
                                                                {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.firstName} */}

                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.firstName == ""
                                                                    ? "-"
                                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.firstName}
                                                            </Col>
                                                        </Row>
                                                        <hr />
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Father/Spouse Name:	:</Col>
                                                            <Col md={6}>


                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.fatherOrSpouseName == ""
                                                                    ? "-"
                                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.fatherOrSpouseName}
                                                            </Col>
                                                        </Row>
                                                        <hr />
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Mother Name:: </Col>
                                                            <Col md={6}>


                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.motherName == ""
                                                                    ? "-"
                                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.motherName}
                                                            </Col>
                                                        </Row>

                                                        <hr />
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Date of Birth:</Col>
                                                            <Col md={6}>


                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.address == ""
                                                                    ? "-"
                                                                    : viewProfileArray.viewProfileArray &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.address}
                                                            </Col>
                                                        </Row>
                                                        <hr />
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Gender:</Col>
                                                            <Col md={6}>


                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.postalCode == ""
                                                                    ? "-"
                                                                    : viewProfileArray.viewProfileArray &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList &&
                                                                    viewProfileArray
                                                                        .customerMasterDetailsResponseVO
                                                                        .businessPersonRequestVOList.postalCode}
                                                            </Col>
                                                        </Row>
                                                        <hr />
                                                        <Row className="detail-info row">
                                                            <Col md={6}>Phone No:</Col>
                                                            <Col md={6}>
                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                                        .mobNumber == ""
                                                                    ? "-"
                                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                                        .mobNumber
                                                                }

                                                            </Col>
                                                        </Row>

                                                        <hr />

                                                        <Row className="detail-info row">
                                                            <Col md={6}>Customer Ip Address:</Col>
                                                            <Col md={6}>
                                                                {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                                        .ipAddress == ""
                                                                    ? "-"
                                                                    : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                    viewProfileArray.customerMasterDetailsResponseVO
                                                                        .ipAddress
                                                                }

                                                            </Col>
                                                        </Row>
                                                        <hr />


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray.customerMasterDetailsResponseVO
                                                                .userMasterKYCVOList &&
                                                            [].concat(
                                                                viewProfileArray.customerMasterDetailsResponseVO
                                                                    .userMasterKYCVOList
                                                            ) ? (
                                                            <div
                                                                style={{
                                                                    marginTop: "2rem"
                                                                }}
                                                            >
                                                                {/* <Accordion> */}
                                                                {/* <AccordionSummary
                                                                        expandIcon={<ExpandMore />}
                                                                        aria-controls="panel1a-content"
                                                                        id="panel1a-header"
                                                                    >
                                                                        <Typography
                                                                            style={{
                                                                                color: "#013c83"
                                                                            }}
                                                                        >
                                                                            Document Details
                                                                        </Typography>
                                                                    </AccordionSummary> */}
                                                                {/* <AccordionDetails style={{ display: "unset" }}> */}
                                                                {/* <Col md={12}> */}

                                                                <Row
                                                                    className="detail-info row"
                                                                    style={{ marginBottom: "2rem" }}
                                                                >
                                                                    <Col md={6}>Profile Pic:</Col>
                                                                    <Col md={6}>
                                                                        {viewProfileArray
                                                                            .customerMasterDetailsResponseVO
                                                                            .userMasterKYCVOList &&
                                                                            []
                                                                                .concat(
                                                                                    viewProfileArray
                                                                                        .customerMasterDetailsResponseVO
                                                                                        .userMasterKYCVOList
                                                                                )
                                                                                .map((x) => (
                                                                                    <>
                                                                                        <img
                                                                                            src={`data:image/jpeg;base64,${x.selfie}`}
                                                                                            style={{ maxWidth: "100%" }}
                                                                                        />
                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "space-around",
                                                                                                marginTop: "15px"
                                                                                            }}
                                                                                        >
                                                                                            <h6 style={{ display: "inline" }}>
                                                                                                {x.userPhotoIdFileName}
                                                                                            </h6>
                                                                                            <a
                                                                                                download={x.userPhotoIdFileName}
                                                                                                href={`data:image/jpeg;base64,${x.selfie}`}
                                                                                            >
                                                                                                <GetAppIcon />
                                                                                            </a>
                                                                                        </div>
                                                                                        <br />
                                                                                        <br />
                                                                                    </>
                                                                                ))}


                                                                    </Col>
                                                                </Row>
                                                                <hr />
                                                                <Row
                                                                    className="detail-info row"
                                                                    style={{ marginBottom: "2rem" }}
                                                                >
                                                                    <Col md={6}>Signature:</Col>
                                                                    <Col md={6}>
                                                                        {viewProfileArray
                                                                            .customerMasterDetailsResponseVO
                                                                            .userMasterKYCVOList &&
                                                                            []
                                                                                .concat(
                                                                                    viewProfileArray
                                                                                        .customerMasterDetailsResponseVO
                                                                                        .userMasterKYCVOList
                                                                                )
                                                                                .map((x) => (
                                                                                    <>
                                                                                        <img
                                                                                            src={`data:image/jpeg;base64,${x.signature}`}
                                                                                            style={{ maxWidth: "100%" }}
                                                                                        />
                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "space-around",
                                                                                                marginTop: "15px"
                                                                                            }}
                                                                                        >
                                                                                            {/* <h6 style={{ display: "inline" }}>
                                                                                                {x.signature}
                                                                                            </h6> */}
                                                                                            <a
                                                                                                download={x.signature}
                                                                                                href={`data:image/jpeg;base64,${x.signature}`}
                                                                                            >
                                                                                                <GetAppIcon />
                                                                                            </a>
                                                                                        </div>
                                                                                        <br />
                                                                                        <br />
                                                                                    </>
                                                                                ))}


                                                                    </Col>
                                                                </Row>
                                                                <hr />
                                                                <Row className="detail-info row">
                                                                    <Col md={6}>Name:</Col>
                                                                    <Col md={6}>


                                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.firstName == ""
                                                                            ? "-"
                                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.firstName}
                                                                    </Col>
                                                                </Row>
                                                                <hr />
                                                                <Row className="detail-info row">
                                                                    <Col md={6}>Email ID:</Col>
                                                                    <Col md={6}>


                                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.state == ""
                                                                            ? "-"
                                                                            : viewProfileArray.viewProfileArray &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.state}
                                                                    </Col>
                                                                </Row>
                                                                <hr />

                                                                <Row className="detail-info row">
                                                                    <Col md={6}>Date of Birth:</Col>
                                                                    <Col md={6}>


                                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.address == ""
                                                                            ? "-"
                                                                            : viewProfileArray.viewProfileArray &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.address}
                                                                    </Col>
                                                                </Row>
                                                                <hr />
                                                                <Row className="detail-info row">
                                                                    <Col md={6}>Nid Number:</Col>
                                                                    <Col md={6}>


                                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.city == ""
                                                                            ? "-"
                                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.city}
                                                                    </Col>
                                                                </Row>
                                                                <hr />
                                                                <Row
                                                                    className="detail-info row"
                                                                    style={{ marginBottom: "2rem" }}
                                                                >
                                                                    <Col md={6}>Back Photo:</Col>
                                                                    <Col md={6}>
                                                                        {viewProfileArray
                                                                            .customerMasterDetailsResponseVO
                                                                            .userMasterKYCVOList &&
                                                                            []
                                                                                .concat(
                                                                                    viewProfileArray
                                                                                        .customerMasterDetailsResponseVO
                                                                                        .userMasterKYCVOList
                                                                                )
                                                                                .map((x) => (
                                                                                    <>
                                                                                        <img
                                                                                            src={`data:image/jpeg;base64,${x.base64UserPhotoBack}`}
                                                                                            style={{ maxWidth: "100%" }}
                                                                                        />
                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "space-around",
                                                                                                marginTop: "15px"
                                                                                            }}
                                                                                        >
                                                                                            <h6 style={{ display: "inline" }}>
                                                                                                {x.userPhotoIdBackFileName}
                                                                                            </h6>
                                                                                            <a
                                                                                                download={x.userPhotoIdBackFileName}
                                                                                                href={`data:image/jpeg;base64,${x.userPhotoIdBackFileName}`}
                                                                                            >
                                                                                                <GetAppIcon />
                                                                                            </a>
                                                                                        </div>
                                                                                        <br />
                                                                                        <br />
                                                                                    </>
                                                                                ))}


                                                                    </Col>
                                                                </Row>


                                                                <hr />
                                                                <Row className="detail-info row">
                                                                    <Col md={6}>Address:</Col>
                                                                    <Col md={6}>


                                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.address == ""
                                                                            ? "-"
                                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList &&
                                                                            viewProfileArray
                                                                                .customerMasterDetailsResponseVO
                                                                                .businessPersonRequestVOList.address}
                                                                    </Col>
                                                                </Row>

                                                                {/* <Col md={6}>
                                                                        {viewProfileArray
                                                                            .customerMasterDetailsResponseVO
                                                                            .userMasterKYCVOList &&
                                                                            []
                                                                                .concat(
                                                                                    viewProfileArray
                                                                                        .customerMasterDetailsResponseVO
                                                                                        .userMasterKYCVOList
                                                                                )
                                                                                .map((x) => (
                                                                                    <>
                                                                                        <img
                                                                                            src={`data:image/jpeg;base64,${x.selfie}`}
                                                                                            style={{ maxWidth: "100%" }}
                                                                                        />
                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "space-around",
                                                                                                marginTop: "15px"
                                                                                            }}
                                                                                        >
                                                                                            <h6 style={{ display: "inline" }}>
                                                                                                {x.userPhotoIdFileName}
                                                                                            </h6>
                                                                                            <a
                                                                                                download={x.userPhotoIdFileName}
                                                                                                href={`data:image/jpeg;base64,${x.selfie}`}
                                                                                            >
                                                                                                <GetAppIcon />
                                                                                            </a>
                                                                                        </div>
                                                                                        <br />
                                                                                        <br />
                                                                                    </>
                                                                                ))}


                                                                    </Col>
                                                                    <Col md={6}>
                                                                        {viewProfileArray
                                                                            .customerMasterDetailsResponseVO
                                                                            .userMasterKYCVOList &&
                                                                            []
                                                                                .concat(
                                                                                    viewProfileArray
                                                                                        .customerMasterDetailsResponseVO
                                                                                        .userMasterKYCVOList
                                                                                )
                                                                                .map((x) => (
                                                                                    <>
                                                                                        <img
                                                                                            src={`data:image/jpeg;base64,${x.signature}`}
                                                                                            style={{ maxWidth: "100%" }}
                                                                                        />
                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                justifyContent: "space-around",
                                                                                                marginTop: "15px"
                                                                                            }}
                                                                                        >
                                                                                      
                                                                                            <a
                                                                                              
                                                                                                href={`data:image/jpeg;base64,${x.signature}`}
                                                                                            >
                                                                                                <GetAppIcon />
                                                                                            </a>
                                                                                        </div>
                                                                                        <br />
                                                                                        <br />
                                                                                    </>
                                                                                ))}


                                                                    </Col> */}
                                                                {/* </Row> */}
                                                                <br />
                                                                {/* </Col> */}
                                                                {/* </AccordionDetails> */}
                                                                {/* </Accordion> */}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </Col>
                                                </Typography>

                                            </AccordionDetails>

                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}

                        {/* <div style={{ marginTop: "2rem" }}>


                            <Row
                                className="detail-info row"
                                style={{ marginBottom: "2rem" }}
                            >
                                <Col sm={12} md={5}>
                                    {viewDealerProfileRes && viewDealerProfileRes.data && viewDealerProfileRes.data.userMasterKYCVOList && viewDealerProfileRes.data.userMasterKYCVOList.base64UserPhotoBack && <Card >
                                        <CardTitle>
                                            <h6>Front Pic</h6>

                                        </CardTitle>
                                        <CardBody>
                                            <img
                                                src={`data:image/jpeg;base64,${viewDealerProfileRes.data.userMasterKYCVOList.base64UserPhotoBack}`}
                                                style={{ maxWidth: "100%" }}
                                            />
                                            <br />
                                            <br />
                                            <h6 style={{ display: "inline" }}>
                                                {viewDealerProfileRes.data.userMasterKYCVOList.userPhotoIdBackFileName}
                                            </h6>
                                            <a
                                                download={viewDealerProfileRes.data.userMasterKYCVOList.userPhotoIdBackFileName}
                                                href={`data:image/jpeg;base64,${viewDealerProfileRes.data.userMasterKYCVOList.base64UserPhotoBack}`}
                                            >
                                                <GetAppIcon />
                                            </a>
                                        </CardBody>
                                    </Card>}
                                </Col>




                            </Row>


                        </div> */}

                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .businessAccountMasterVOList ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ color: "#013c83" }}>
                                            Company Details
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Typography>
                                            <Col md={12}>
                                                <Row className="detail-info row">
                                                    <Col md={6}>Company ID:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.personId} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.companyId == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.companyId}

                                                    </Col>
                                                </Row>

                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Company Name:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.firstName} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.companyName == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.companyName}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Organization Type:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.userType == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.userType}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Business Type:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.businessNature == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.businessNature}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Business Phone Number:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.businessContactNumber == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.businessContactNumber}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Outlet Infra:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.outletInfra == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.outletInfra}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Outlet Infra Ownership:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.outletInfraOwnership == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.outletInfraOwnership}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>VAT ID:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.vatNumber == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.vatNumber}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>TAX ID:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.taxNumber == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.taxNumber}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Trade License No:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.tradeLicenseNumber == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.tradeLicenseNumber}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Trade License Authority:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.tradeLicenseAuthority == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.tradeLicenseAuthority}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Trade License Validity:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.tradeLicenseValidity == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAccountMasterVOList.tradeLicenseValidity}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}

                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .merchantAddressRequestVOList ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ color: "#013c83" }}>
                                            Merchant Owner Address Details

                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Typography>
                                            <Col md={12}>
                                                <Row className="detail-info row">
                                                    <Col md={6}>Address:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.personId} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.merchantOwnerAddress == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.merchantOwnerAddress}

                                                    </Col>
                                                </Row>

                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>District:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.firstName} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.state == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.state}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Thana/Upazilla:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.city == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.city}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Union/Ward:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.union == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.union}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Postal Code:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.postalCode == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .merchantAddressRequestVOList.postalCode}
                                                    </Col>
                                                </Row>


                                            </Col>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}

                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .businessAddressRequestVOList ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ color: "#013c83" }}>
                                            Business Address Details

                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Typography>
                                            <Col md={12}>
                                                <Row className="detail-info row">
                                                    <Col md={6}>Address:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.personId} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.businessAddress == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.businessAddress}

                                                    </Col>
                                                </Row>

                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Location Type:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.firstName} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.locationType == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.locationType}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>District:</Col>
                                                    <Col md={6}>
                                                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO.businessPersonRequestVOList.firstName} */}

                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.state == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.state}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Thana/Upazilla:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.city == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.city}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Union/Ward:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.union == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.union}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Postal Code:</Col>
                                                    <Col md={6}>


                                                        {viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.postalCode == ""
                                                            ? "-"
                                                            : viewProfileArray.customerMasterDetailsResponseVO &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList &&
                                                            viewProfileArray
                                                                .customerMasterDetailsResponseVO
                                                                .businessAddressRequestVOList.postalCode}
                                                    </Col>
                                                </Row>


                                            </Col>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}

                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .kybDetailsList ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ color: "#013c83" }}>
                                            KYB Details

                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Typography>
                                            <Col md={12}>
                                                <Row className="detail-info row">
                                                    <Col md={6}>Action: </Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.action == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.action}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification ID:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.regFraudId == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.regFraudId}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Request ID:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.fraudScore == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.fraudScore}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Request status:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.requestStatus == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.requestStatus}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Request Date:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.requestTime == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.requestTime}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Response ID:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.fraudScore == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.fraudScore}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification status:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.recommendation == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.recommendation}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification Description:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.description == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.description}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verification Type:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.checkType == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.checkType}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Score:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.fraudScore == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.fraudScore}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Recommendation:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.recommendation == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.recommendation}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Confidence Level:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.confidenceLevel == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.confidenceLevel}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verified On:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.lastUpdatedTime == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.lastUpdatedTime}
                                                </Row>
                                                <hr />
                                                <Row className="detail-info row">
                                                    <Col md={6}>Verified By:</Col>

                                                    {viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.modifiedBy == ""
                                                        ? "-"
                                                        : viewProfileArray.customerMasterDetailsResponseVO &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList &&
                                                        viewProfileArray
                                                            .customerMasterDetailsResponseVO
                                                            .kybDetailsList.modifiedBy}
                                                </Row>


                                            </Col>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}




                        {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .userMasterKYCVOList1 &&
                            [].concat(
                                viewProfileArray.customerMasterDetailsResponseVO
                                    .userMasterKYCVOList1
                            ) ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography
                                            style={{
                                                color: "#013c83"
                                            }}
                                        >
                                            KYB Document Details

                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Col md={12}>

                                            <Row
                                                className="detail-info row"
                                                style={{ marginBottom: "2rem" }}
                                            >
                                                {/* <Col md={4}>File Image:</Col> */}
                                                <Col md={6}>
                                                    {viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .userMasterKYCVOList1 &&
                                                        []
                                                            .concat(
                                                                viewProfileArray
                                                                    .customerMasterDetailsResponseVO
                                                                    .userMasterKYCVOList1
                                                            )
                                                            .map((x) => (
                                                                <>
                                                                    <img
                                                                        src={`data:image/jpeg;base64,${x.docBase64}`}
                                                                        style={{ maxWidth: "100%" }}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-around",
                                                                            marginTop: "15px"
                                                                        }}
                                                                    >
                                                                        <h6 style={{ display: "inline" }}>
                                                                            {x.documentFileName}
                                                                        </h6>
                                                                        <a
                                                                            download={x.documentFileName}
                                                                            href={`data:image/jpeg;base64,${x.docBase64}`}
                                                                        >
                                                                            <GetAppIcon />
                                                                        </a>
                                                                    </div>
                                                                    <br />
                                                                    <br />
                                                                </>
                                                            ))}

                                                    {/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((name) => (
                                  <h6>{name.userPhotoIdFileName}</h6>
                                ))} */}
                                                </Col>

                                            </Row>
                                            <br />
                                        </Col>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )}



                        {/* {viewProfileArray.customerMasterDetailsResponseVO &&
                            viewProfileArray.customerMasterDetailsResponseVO
                                .userMasterKYCVOList &&
                            [].concat(
                                viewProfileArray.customerMasterDetailsResponseVO
                                    .userMasterKYCVOList
                            ) ? (
                            <div
                                style={{
                                    marginTop: "2rem"
                                }}
                            >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography
                                            style={{
                                                color: "#013c83"
                                            }}
                                        >
                                            Document Details
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ display: "unset" }}>
                                        <Col md={12}>

                                            <Row
                                                className="detail-info row"
                                                style={{ marginBottom: "2rem" }}
                                            >
                                            
                                                <Col md={6}>
                                                    {viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .userMasterKYCVOList &&
                                                        []
                                                            .concat(
                                                                viewProfileArray
                                                                    .customerMasterDetailsResponseVO
                                                                    .userMasterKYCVOList
                                                            )
                                                            .map((x) => (
                                                                <>
                                                                    <img
                                                                        src={`data:image/jpeg;base64,${x.base64UserPhotoBack}`}
                                                                        style={{ maxWidth: "100%" }}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-around",
                                                                            marginTop: "15px"
                                                                        }}
                                                                    >
                                                                        <h6 style={{ display: "inline" }}>
                                                                            {x.userPhotoIdBackFileName}
                                                                        </h6>
                                                                        <a
                                                                            download={x.userPhotoIdBackFileName}
                                                                            href={`data:image/jpeg;base64,${x.base64UserPhotoBack}`}
                                                                        >
                                                                            <GetAppIcon />
                                                                        </a>
                                                                    </div>
                                                                    <br />
                                                                    <br />
                                                                </>
                                                            ))}


                                                </Col>
                                                <Col md={6}>
                                                    {viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .userMasterKYCVOList &&
                                                        []
                                                            .concat(
                                                                viewProfileArray
                                                                    .customerMasterDetailsResponseVO
                                                                    .userMasterKYCVOList
                                                            )
                                                            .map((x) => (
                                                                <>
                                                                    <img
                                                                        src={`data:image/jpeg;base64,${x.selfie}`}
                                                                        style={{ maxWidth: "100%" }}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-around",
                                                                            marginTop: "15px"
                                                                        }}
                                                                    >
                                                                        <h6 style={{ display: "inline" }}>
                                                                            {x.userPhotoIdFileName}
                                                                        </h6>
                                                                        <a
                                                                            download={x.userPhotoIdFileName}
                                                                            href={`data:image/jpeg;base64,${x.selfie}`}
                                                                        >
                                                                            <GetAppIcon />
                                                                        </a>
                                                                    </div>
                                                                    <br />
                                                                    <br />
                                                                </>
                                                            ))}


                                                </Col>
                                                <Col md={6}>
                                                    {viewProfileArray
                                                        .customerMasterDetailsResponseVO
                                                        .userMasterKYCVOList &&
                                                        []
                                                            .concat(
                                                                viewProfileArray
                                                                    .customerMasterDetailsResponseVO
                                                                    .userMasterKYCVOList
                                                            )
                                                            .map((x) => (
                                                                <>
                                                                    <img
                                                                        src={`data:image/jpeg;base64,${x.signature}`}
                                                                        style={{ maxWidth: "100%" }}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-around",
                                                                            marginTop: "15px"
                                                                        }}
                                                                    >
                                                    
                                                                        <a
                                                                         
                                                                            href={`data:image/jpeg;base64,${x.signature}`}
                                                                        >
                                                                            <GetAppIcon />
                                                                        </a>
                                                                    </div>
                                                                    <br />
                                                                    <br />
                                                                </>
                                                            ))}


                                                </Col>
                                            </Row>
                                            <br />
                                        </Col>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        ) : (
                            ""
                        )} */}

                    </Box>
                </div>
            </Layout>
        </>
    )
}

export default DealerViewUserMaster


